export const authRoles = {
  admin: "Admin",
  editor: "Editor",
  guest: "Guest",
};